module.exports = __webpack_public_path__ + "static/media/mongo.89164ff4.png";